import { render } from "./PaiceSettingsConflict.vue?vue&type=template&id=671819e2&scoped=true"
import script from "./PaiceSettingsConflict.vue?vue&type=script&lang=js"
export * from "./PaiceSettingsConflict.vue?vue&type=script&lang=js"

import "./PaiceSettingsConflict.vue?vue&type=style&index=0&id=671819e2&scoped=true&lang=css"
import "./PaiceSettingsConflict.vue?vue&type=style&index=1&id=671819e2&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671819e2"]])

export default __exports__